import log from 'salvo-lite/log'
import { tns } from 'tiny-slider/src/tiny-slider'

class Slider {
    constructor (theme, elem) {
        this._elem = elem
        this._options = Object.assign({
            container: elem
        }, JSON.parse(elem.dataset.slider || '{}'))
        this._slider = null
        this._preloads = this._elem.querySelectorAll('[data-preload]')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initialising...', this)
        if (this._elem.title === 'BLAKE Folio Case with Card Pocket for iPhone XS Max in Tahiti Blue / Gunmetal Electroplated') {
            console.log('here')
        }
        this.preloadItems()
    }

    preloadItems () {
        let completedPreloads = 0
        if (this._preloads.length) {
            for (let elem of this._preloads) {
                elem.addEventListener('preload-complete', e => {
                    completedPreloads++
                    if (completedPreloads === this._preloads.length) {
                        this.init()
                    }
                })
            }
        } else {
            this.init()
        }
    }

    _setHeight () {
        if (this._options.setHeight) {
            this._elem.style.height = `${this._elem.getBoundingClientRect().height}px`
        }
    }

    goToSlide (x) {
        this._slider.goTo(x)
    }

    init () {
        this._slider = tns(this._options)

        // console.log(this._elem)

        this._elem.addEventListener('click', (e) => {
            e.preventDefault()
        })

        this._elem.addEventListener('click', (e) => {
            if (this._elem.href) {
                window.location.href = this._elem.href
            }
        })

        // let controls = this._elem.closest('.tns-outer').querySelectorAll('[data-controls]')
        // console.log(controls)

        // controls.forEach((control) => {
        //     control.addEventListener('click', (e) => {
        //         e.stopImmediatePropagation()
        //         console.log(control)
        //     })
        // })
        // let name = this._elem.closest('.tns-outer').id
        // window[`slider-${name}`] = this._slider

        this._slider.events.on('transitionEnd', () => {
            this._setHeight()
        })
    }
}

export default Slider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slider.js